import * as React from "react"
import type { SVGProps } from "react"
const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 12.03v-3.6a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7v3.98a1 1 0 0 0 .3.73l3.3 3.3a1 1 0 0 0 .7.27 1 1 0 0 0 .7-.27 1 1 0 0 0 .27-.7 1 1 0 0 0-.27-.7zm-1 10.4a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17 10 10 0 0 1-.79-3.9q0-2.07.79-3.9a10 10 0 0 1 2.13-3.18Q6.28 4.01 8.1 3.22a10 10 0 0 1 3.9-.8q2.07 0 3.9.8a10 10 0 0 1 3.18 2.13q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.36-3.17 2.14a10 10 0 0 1-3.9.79m0-2q3.33 0 5.66-2.34A7.7 7.7 0 0 0 20 12.43q0-3.32-2.34-5.66T12 4.43c-3.33 0-4.1.78-5.66 2.34A7.7 7.7 0 0 0 4 12.43q0 3.32 2.34 5.66A7.7 7.7 0 0 0 12 20.43" />
  </svg>
)
export default SvgClock
